import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Snowfall from '../Snowfall/Snowfall';
import './Layout.scss';

const Layout = () => {
    const [bgHeight, setBgHeight] = useState('100vh');
    const location = useLocation();
    const isLetterPage = location.pathname === '/letter';

    useEffect(() => {
        // Функция для установки высоты фона
        const updateHeight = () => {
            // Устанавливаем высоту равную текущей высоте окна
            // Это фиксирует фон и предотвращает его сжатие при открытии клавиатуры
            setBgHeight(`${window.innerHeight}px`);
        };

        // Устанавливаем начальную высоту
        updateHeight();

        // Обновляем высоту только при изменении ширины (поворот экрана)
        // Игнорируем изменение высоты, так как это скорее всего клавиатура
        let lastWidth = window.innerWidth;

        const handleResize = () => {
            const currentWidth = window.innerWidth;
            if (currentWidth !== lastWidth) {
                lastWidth = currentWidth;
                updateHeight();
            }
        };

        window.addEventListener('resize', handleResize);

        // Дополнительно для мобильных браузеров можно слушать orientationchange
        window.addEventListener('orientationchange', updateHeight);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', updateHeight);
        };
    }, []);

    return (
        <div className="app-layout">
            <div
                className={`background-layer ${isLetterPage ? 'hide-gradient' : ''}`}
                style={{ height: bgHeight }}
            />
            <Snowfall />
            <div className="content-layer">
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;
